import React, { useContext } from 'react';
//import { useUserSelector } from 'hooks/useUser';
//import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';

const FlagsContext = React.createContext(null);

export function FlagsContextProvider({ children }) {
  //const { user } = useUserSelector();
  //const ldFlags = useLDFlags();

  return (
    <FlagsContext.Provider
      value={{
        foo: 'bar'
      }}
    >
      {children}
    </FlagsContext.Provider>
  );
}

export function useFlags() {
  const context = useContext(FlagsContext);

  if (!context) {
    throw new Error('useReferral must be used within a FlagsContextProvider');
  }

  return context;
}
